import axiosInstance from './AxiosInstance';

const PreTicketService = {
  fetchPreTicket: async (page, pageSize, poNumber, sortBy , order = 'asc') => {
    try {
      const params = { 
        page, 
        pageSize
      };
      
      // Only add poNumber to params if it exists
      if (poNumber) {
        params.poNumber = poNumber;
      }

      // Add sorting parameters
      if (sortBy) {
        params.sortBy = sortBy;
      }
      if (order) {
        params.order = order;
      }

      const response = await axiosInstance.get('/po', { params });
      console.info("response------>>>>>>>>>>", response);
      return response.data;
    } catch (error) {
      console.error('Error fetching PreTicket:', error);
      throw error;
    }
  },

  updatePreTicket: async (po_number, data) => {
    console.log("id-----------", po_number, data);
    try {
      const response = await axiosInstance.put(`/po/${po_number}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating PreTicket with ID ${po_number}:`, error);
      throw error;
    }
  },
};

export default PreTicketService;